import { Injectable, signal, Signal, computed, inject } from "@angular/core";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { filter, map, switchMap } from "rxjs/operators";
import { SaleTripService } from "../pages/sale/sale-trip/sale-trip.service";
import { StateService } from "./state.service";
import { toSignal } from "@angular/core/rxjs-interop";
import { lastValueFrom, of } from "rxjs";

@Injectable({ providedIn: "root" })
export class RoutingService {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private translate = inject(TranslateService);
  private saleTripService = inject(SaleTripService);
  private stateService = inject(StateService);

  private _url = signal<string>("/");
  private _language = signal(this.translate.currentLang);
  public url: Signal<string> = this._url.asReadonly();

  
public pageName = toSignal(
  this.router.events.pipe(
    filter((e): e is NavigationEnd => e instanceof NavigationEnd),
    map(() => this.getDeepestChild(this.activatedRoute)),
    switchMap(route => route.data),
    map(d => { 
      console.log(`PageTitle: ${d['pageTitle']}`);
      return d['pageTitle'] as string;
    } ),
    switchMap(key => {
      var t = key ? this.translate.get(key) : of('');
      return t;
    })
  ),
  { initialValue: '' }
);

private getDeepestChild(route: ActivatedRoute): ActivatedRoute {
  while (route.firstChild) {
    route = route.firstChild;
  }
  return route;
}

  constructor() {
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        map((e) => e.urlAfterRedirects)
      )
      .subscribe((url) => {
        this._url.set(url);
        this.stateService.pageNameOverride.set(null);
      });

    this.translate.onLangChange.subscribe((event) => {
      this._language.set(event.lang);
    });
  }

  private clearData(lastSegment: string) {
    this.clearTripData(lastSegment);
  }

  private clearTripData(lastSegment: string) {
    lastSegment === "trip" || lastSegment === "trip-return"
      ? null
      : this.saleTripService.clearData();
  }

  private getPageName(lastSegment: string): string {
    switch (lastSegment) {
      case "dashboard":
        return "Dashboard";
      case "financial-documents":
        return this.translate.instant("webPos.FinancialDocuments");
      case "sale":
        return this.translate.instant("webPos.saleTrans");
      case "return":
        return this.translate.instant("webPos.Return");
      case "trip":
        return this.translate.instant("webPos.Trip.TripNavigation");
      case "trip-return":
        return this.translate.instant("webPos.Trip.TripRefundNavigation");
      case "fly-ticket":
        return this.translate.instant("webPos.FlyTicketNavigation");
      case "e-travel":
        return this.translate.instant("webPos.ETravel");
      case "fly-ticket-return":
        return this.translate.instant("webPos.FlyTicketRefundNavigation");
      case "voucher":
        return this.translate.instant("webPos.Voucher.Voucher");
      default:
        return lastSegment;
    }
  }
}
